import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { PageContext } from './Page';
import {useContext} from 'react';

export default function VerticalLinearStepper() {
  const context = useContext(PageContext);
  const maybe_subsequent = context.pageTitle === 'home' ? 'on the subsequent page' : '';

  const steps = [
    {
      label: 'Select the IFC file(s) you want to validate',
      description: ``,
    },
    {
      label: 'Click on "Upload & Validate"',
      description:
        '',
    },
    {
      label: `Check the detailed results by clicking on the icons ${maybe_subsequent}`,
      description: ``,
    }
  ];

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.label} active = {true} >
            <StepLabel>
              {step.label}
            </StepLabel>
            <StepContent>
              {/* <Typography>{step.description}</Typography> */}
              <Box sx={{ mb: 2 }}>
                <div>
              
                </div>
              </Box>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}